import StringHelper from "@helpers/StringHelper";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { TextInput } from "@mantine/core";
import useUserStore from "@store/user.store";
import type { GetInputPropsReturnType } from "node_modules/@mantine/form/lib/types";
import { useState } from "react";

const BasketEmailInput: React.FC<
  GetInputPropsReturnType & { sanitizeCart: () => void }
> = ({ sanitizeCart, ...rest }) => {
  const { t } = useAppTranslation("pages.order.basket.emailInput");
  const [oldValue, setValue] = useState("");
  const { isLogin } = useUserStore();

  const handleBlur = () => {
    if (!StringHelper.isValidEmail(rest.value)) return;

    if (rest.value === oldValue) return;

    sanitizeCart();
  };

  if (isLogin) return undefined;

  return (
    <TextInput
      disabled={isLogin}
      withAsterisk
      classNames={{
        root: "basket-container",
        label: "text-primary-white font-bold font-secret-narrow text-sm",
        input:
          "bg-primary-darker text-primary-light-text rounded-lg disabled:bg-primary-default",
      }}
      description={t("description")}
      label={t("label")}
      placeholder={t("placeholder")}
      autoFocus
      {...rest}
      onFocus={() => setValue(rest.value)}
      onBlur={handleBlur}
    />
  );
};

export default BasketEmailInput;
